export default __webpack_public_path__ + "static/cs-1-56d6dbf63596bf77d48bca9029036102.png";